// Constants
import { API } from './constants';

// Utils
import { apiFetch, HEADERS } from '../shared/utils/api';


class AuthenticationApi {
  static loginUser(username, password, rememberMe = 'on') {
    const method = 'POST';
    const headers = {
      'Content-Type': HEADERS.CONTENT_TYPE.APP_X_WWW_FORM_URLENCODED
    };
    const body = {
      j_username: username, j_password: password, RememberMe: rememberMe
    };
    const requestOptions = { method, headers, body };

    return apiFetch(API.AUTHENTICATION.LOGIN_USER, requestOptions);
  }

  static loginGuestUser(params) {
    const body = { ...params };
    const requestOptions = { method: 'POST', body };

    return apiFetch(API.AUTHENTICATION.LOGIN_GUEST_USER, requestOptions);
  }

  static fetchUserInfo(token) {
    const headers = { token };
    const requestOptions = { headers };

    return apiFetch(API.AUTHENTICATION.USER_INFO, requestOptions);
  }

  static fetchProfile(token) {
    const headers = { token };
    const requestOptions = { headers };

    return apiFetch(API.AUTHENTICATION.PROFILE, requestOptions);
  }
}

export default AuthenticationApi;
